import { CostSummary } from '@dgx-pr-spa/shared/util';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cost-summary',
  templateUrl: './cost-summary.component.html',
  styleUrls: ['./cost-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostSummaryComponent {
  @Input() data: CostSummary;
  /**
   * Boolean to determine whether to show policy comparison via optimizely
   */
  @Input() optimizely = false;
}
